<template>
  <div class="nebRangeSelectDropdown">
    <div class="nebRangeSelectDropdown-chart">
      <chart v-if="data !== null"
        :chartData="data"
        width="330px"
        height="120px"
        :selectionMin="min"
        :selectionMax="max"
        @select="onChartSelect"
        @ready="onChartReady"
      ></chart>
      <div class="nebRangeSelectDropdown-chart-noData"
        v-if="data === null"
      >
        <p>Sorry! There is not enough data to calculate!</p>
      </div>
    </div>

    <div class="nebRangeSelectDropdown-info"
      v-if="data !== null"
    >
      <neb-form-control label="Min Value">
        <neb-input :value="String(selectionMin)"
          @input="onMinInput"
        ></neb-input>
      </neb-form-control>
      <div style="padding-top: 14px;">
        <span>—</span>
      </div>
      <neb-form-control label="Max Value">
        <neb-input :value="String(selectionMax)"
          @input="onMaxInput"
        ></neb-input>
      </neb-form-control>
    </div>

    <div class="nebRangeSelectDropdown-controls"
      v-if="data !== null"
    >
      <neb-form-control>
        <neb-button type="text"
          @click="onReset"
        >
          Reset
        </neb-button>
      </neb-form-control>
      <neb-form-control>
        <neb-button type="textPrimary"
          @click="onSave"
        >
          Save
        </neb-button>
      </neb-form-control>
    </div>
  </div>
</template>

<script>
import { min, max } from 'lodash'

import Chart from './Chart'
import NebButton from '../Button'
import NebFormControl from '../FormControl'
import NebInput from '../Input'

export default {
  name: 'NebRangeSelectDropdown',

  components: {
    Chart,
    NebButton,
    NebFormControl,
    NebInput
  },

  props: {
    data: {
      type: [Array, null],
      default: () => []
    },
    value: {
      type: Array,
      default: () => [ 0, 0 ]
    },
    title: {
      type: String,
      default: null
    }
  },

  data: () => ({
    selectionData: [],
    min: 0,
    max: 0
  }),

  computed: {
    min_: {
      get () { return this.min },
      set (value) {
        this.selectionData = [ Number(value), this.selectionData[1] ]
        this.min = ((Number(value) - this.dataMin) / this.dataRange) * 380
      }
    },
    max_: {
      get () { return this.max },
      set (value) {
        this.selectionData = [ this.selectionData[0], Number(value) ]
        this.max = ((Number(value) - this.dataMin) / this.dataRange) * 380
      }
    },
    dataMin () {
      return Math.round(min(
        this.data.map(d => d.left)
      ))
    },
    dataMax () {
      return Math.round(max(
        this.data.map(d => d.right)
      ))
    },
    dataRange () {
      return this.dataMax - this.dataMin
    },
    selectionMin () {
      if (!this.selectionData.length) { return 0 }

      return Math.round(this.selectionData[0])
    },
    selectionMax () {
      if (!this.selectionData.length) { return this.dataMax }

      return Math.round(this.selectionData[1])
    },
    value_: {
      get () { return this.value },
      set (v) { this.$emit('input', v) }
    }
  },

  methods: {
    onMinInput (v) {
      this.min_ = Number(v)
    },
    onMaxInput (v) {
      this.max_ = Number(v)
    },
    onChartSelect (v) {
      this.selectionData = v || [this.dataMin, this.dataMax]
    },
    onSave () {
      this.value_ = this.selectionData
    },
    async onReset () {
      this.min_ = 1
      this.max_ = 2
      await this.$nextTick()
      this.min_ = 0
      this.max_ = this.dataMax
      this.selectionData = [0, this.dataMax]
    },
    onChartReady () {
      if (this.value.length && this.value !== [0,0]) {
        this.min_ = this.value[0]
        this.max_ = this.value[1]
      } else {
        this.onReset()
      }
    }
  }
}
</script>

<style lang="scss">
.nebRangeSelectDropdown {

  &-info {
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 4px;

    .nebFormControl {
      margin-bottom: 0;
    }
  }

  &-controls {
    display: flex;
    box-sizing: border-box;
    overflow: hidden;
    justify-content: space-between;
    padding: 18px 4px 0 4px;

    .nebFormControl {
      margin-bottom: 0;
    }
  }
}
</style>
